import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../../../../environments/environment';

export interface NotificationSettingsDto {
  merchantLocationId: string;
  reminder24hEnabled: boolean;
  reminderShortEnabled: boolean;
  reminderHoursBefore: number;
  cancellationEnabled: boolean;
  rescheduleEnabled: boolean;
  reviewInvitationEnabled: boolean;
  reviewResponseEnabled: boolean;
  paymentReceivedEnabled: boolean;
  refundProcessedEnabled: boolean;
  updatedAt: string;
}

export interface UpdateNotificationSettingsBody {
  reminder24hEnabled: boolean;
  reminderShortEnabled: boolean;
  reminderHoursBefore: number;
  cancellationEnabled: boolean;
  rescheduleEnabled: boolean;
  reviewInvitationEnabled: boolean;
  reviewResponseEnabled: boolean;
  paymentReceivedEnabled: boolean;
  refundProcessedEnabled: boolean;
}

interface SingleResponse<T> { isSuccess: boolean; value: T; }

/**
 * FAC-45 — wraps the convfact-api proxy for the booking-api notification
 * settings module. Used by the "Notificaciones" sub-section in the
 * location settings form.
 */
@Injectable()
export class LocationNotificationsService {
  private readonly baseUrl = `${environment.apiUrl}/api/v2/booking/merchant-locations`;

  constructor(private readonly http: HttpClient) { }

  getSettings(locationId: string): Observable<NotificationSettingsDto> {
    return this.http
      .get<SingleResponse<NotificationSettingsDto>>(`${this.baseUrl}/${locationId}/notification-settings`)
      .pipe(map(r => r.value));
  }

  updateSettings(locationId: string, body: UpdateNotificationSettingsBody): Observable<NotificationSettingsDto> {
    return this.http
      .put<SingleResponse<NotificationSettingsDto>>(`${this.baseUrl}/${locationId}/notification-settings`, body)
      .pipe(map(r => r.value));
  }
}
